const swiper = new Swiper('.imageSlider', {
	loop: true,
	speed: 3000,
	autoplay: {
		delay: 6000,
	},
});

let slideCount = 0;
const textSlides = document.querySelectorAll('.textSlide');
const nowTextNum = () => {
	let now = 0;
	textSlides.forEach((el, i) => {
		if (el.classList.contains('show')) {
			now = i;
		}
	});
	return now;
};
const nextTextNum = (now) => {
	const next = now + 1;
	if (next > textSlides.length - 1) {
		return 0;
	}
	return next;
};
const changeText = (n) => {
	const now = nowTextNum();
	const next = nextTextNum(now);
	textSlides[now].classList.remove('show');
	textSlides[next].classList.add('show');
};

swiper.on('realIndexChange', (swiper) => {
	slideCount++;
	if (slideCount > 0 && slideCount % 2 === 0) {
		changeText();
	}
});

const headerToggle = () => {
	const headerElm = document.getElementById('side');
	const showClass = 'show';
	let isMobile;
	const _resize = () => {
		isMobile = window.innerWidth < 480;
	};
	const _toggle = () => {
		const trigger = (!isMobile) ? window.innerHeight / 2 : 0;
		if (trigger < document.scrollingElement.scrollTop) {
			if (!headerElm.classList.contains(showClass)) {
				headerElm.classList.add(showClass);
			}
		} else {
			if (headerElm.classList.contains(showClass)) {
				headerElm.classList.remove(showClass);
			}
		}
	};
	window.addEventListener('DOMContentLoaded', _resize);
	window.addEventListener('resize', _resize);
	window.addEventListener('load', _toggle);
	window.addEventListener('scroll', _toggle);
};

headerToggle();

const noMove = () => {
	const limit = 30000;
	let flag = true;
	const checkNoMove = setTimeout(() => {
		if (flag && document.scrollingElement.scrollTop === 0 && window.innerWidth >= 480) {
			window.siteInit.anchorScroll('#main');
		} else {
			clearInterval(checkNoMove);
			return false;
		}
	}, limit);
	const move = () => {
		flag = false;
	};
	window.addEventListener('click', move);
	window.addEventListener('scroll', move);
	window.addEventListener('resize', move);
	window.addEventListener('mousemove', move);
	window.addEventListener('keydown', move);
	window.addEventListener('keyup', move);
};

noMove();

const crouselInit = () => {
	const carouselOptions = {
		about: {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 20,
			pagination: {
				el: ".aboutSlider__pagination",
				type: "progressbar",
			},
			navigation: {
				nextEl: ".aboutSlider__btn--next",
				prevEl: ".aboutSlider__btn--prev",
			},
			breakpoints: {
				480: {
					slidesPerView: 3,
				}
			}
		},
		eventInfo: {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 20,
			width: 300,
			pagination: {
				el: ".eventInfoSlider__pagination",
				type: "progressbar",
			},
			navigation: {
				nextEl: ".eventInfoSlider__btn--next",
				prevEl: ".eventInfoSlider__btn--prev",
			},
			breakpoints: {
				480: {
					slidesPerView: 2,
					width: 800,
				}
			}
		},
		eventRepo: {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 20,
			width: 300,
			pagination: {
				el: ".eventRepoSlider__pagination",
				type: "progressbar",
			},
			navigation: {
				nextEl: ".eventRepoSlider__btn--next",
				prevEl: ".eventRepoSlider__btn--prev",
			},
			breakpoints: {
				480: {
					slidesPerView: 2,
					width: 800,
				}
			}
		},
	};

	const slideItems = {
		about: document.querySelectorAll('.aboutSlider .swiper-slide'),
		eventInfo: document.querySelectorAll('.eventInfoSlider .swiper-slide'),
		eventRepo: document.querySelectorAll('.eventRepoSlider .swiper-slide'),
	};

	if (slideItems.about.length) {
		if (slideItems.about.length === 1) {
			carouselOptions.about.loop = false;
		}
		new Swiper('.aboutSlider', carouselOptions.about);
	}

	if (slideItems.eventInfo.length) {
		if (slideItems.eventInfo.length <= 2) {
			carouselOptions.eventInfo.breakpoints[480].loop = false;
		}
		if (slideItems.eventInfo.length <= 1) {
			carouselOptions.eventInfo.loop = false;
			carouselOptions.eventInfo.width = null;
		}
		new Swiper('.eventInfoSlider', carouselOptions.eventInfo);
	}

	if (slideItems.eventRepo.length) {
		if (slideItems.eventRepo.length <= 2) {
			carouselOptions.eventRepo.breakpoints[480].loop = false;
		}
		if (slideItems.eventRepo.length <= 1) {
			carouselOptions.eventRepo.loop = false;
		}
		new Swiper('.eventRepoSlider', carouselOptions.eventRepo);
	}
};

crouselInit();
